module.exports = __webpack_public_path__ + "img/Red_Space_Invader.03c0af8e.gif";